import { render, staticRenderFns } from "./ApprovalAwait.vue?vue&type=template&id=14133c1e&scoped=true"
import script from "./ApprovalAwait.vue?vue&type=script&lang=js"
export * from "./ApprovalAwait.vue?vue&type=script&lang=js"
import style0 from "./ApprovalAwait.vue?vue&type=style&index=0&id=14133c1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14133c1e",
  null
  
)

export default component.exports